import { useEffect } from 'react';

export const useResetTitleOnVisible = (defaultTitle: string) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        document.title = defaultTitle;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [defaultTitle]);
};
